export default "__VITE_ASSET__B9u_kR7z__"